export const SET_STATE = 'flags/SET_STATE';
export const SET_FLAG = 'flags/SET_FLAG';
export const RESET_STATE = 'flags/RESET_STATE';
